import { useState, useEffect } from 'react';
import NumberFormat from 'react-number-format';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Collapse from '@material-ui/core/Collapse';
import { spacing } from '@material-ui/system';
import { apiClient } from '@services/api';
import Moment from 'react-moment';
import Icon from '@material-ui/core/Icon';
import Checkbox from '@components/Checkbox';
import ChangeStateModal from './ChangeStateModal';

const permissions = ['administrador'];

const TableBodyData = (props) => {

  const [open, setOpen] = useState(false)
  const [tours, setTours] = useState([])
  const types = {
    tour: 'Passeio',
    transfer: 'Transfer',
  }
  const status = {
    canceled: 'Cancelado',
    pending: 'Pendente',
    sended: 'Habilitado',
  }

  useEffect(() => {
    getTours()
  }, [])

  const getTours = () => {
    apiClient.httpInstance.get(`/tours?pageSize=500`).then(response => {
      if (response.status === 200) {
        //console.log('tours', response.data)
        setTours(response.data.data)
      }
    })
      .catch(error => {
        if (error) {
          console.log(error)
        }
      });
  }

  // Fix (2026-08-19): confirmado com dados reais de produção (10 reservas com
  // customer_discount > 0) que `value` (= reservation_brute_value =
  // reservations.price) JÁ vem líquido — já tem customer_discount E
  // manager_discount_pct embutidos (cadeia completa em
  // PreSaleController::convertInSale). O fix de 2026-08-17 citado abaixo
  // "corrigiu" a tela pra bater com o backend, só que o backend também estava
  // errado (CommissionService::createTourCommission tinha o mesmo bug) — os
  // dois lados ficaram consistentes, mas consistentemente errados, descontando
  // os dois descontos DE NOVO em cima de um valor que já era líquido. Agora
  // "valor bruto" = o valor real pago pelo tour = value, sem subtração nenhuma.
  const showFreeValue = (value, total) => {
    return parseFloat(value) || 0
  }

  const getRegionName = () => {
    // Transfer: a regi\u00e3o vem do backend (translados.region_id -> regions.name).
    // N\u00e3o d\u00e1 pra casar pelo nome na lista de tours (transfer n\u00e3o \u00e9 tour) \u2014 por
    // isso antes ca\u00eda sempre em "N/A".
    if (props.reserve?.type === 'transfer' || props.travelType === 'transfer') {
      return props.reserve?.transfer_region_name || 'N/A';
    }
    let actualSale = props.reserve?.travel_name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const selectedTour = tours && tours?.find(tour => tour?.name && tour?.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '') == actualSale)
    return selectedTour ? selectedTour.region_name : "N/A";
  }

  // Regra de negócio (confirmada com o Marcelo, 2026-08-17): o cadastro do tour
  // tem DOIS custos operacionais por adulto/criança — "C. op. Parceiro"
  // (reservations.operational_cost → operational_cost_total no backend) e
  // "C. op. Venda" (reservations.operational_cost_sale → operational_cost_total_sale).
  // Valor livre = valor bruto − custo operacional; a comissão do vendedor é
  // sobre esse valor livre menos a comissão do parceiro (se tiver) e o
  // desconto gerencial (se tiver). Sem parceiro (o caso mais comum) → usa o
  // custo de Venda (operational_cost_total_sale). Com parceiro → usa o custo
  // de Parceiro (operational_cost_total, fonte com fallback pro cadastro do
  // tour — ver backend) pra calcular a comissão do parceiro separadamente.
  let partnerComission = props.reserve.partner_seller_id && props.reserve.partner_seller_type ? props.reserve.percentage_commission : props.reserve.percentage_commission_partner
  let hasPartner = !!(props.reserve.partner_seller_id && props.reserve.partner_seller_type)
  let totalOperationalCostTourView = parseFloat(hasPartner ? props.reserve.operational_cost_total : props.reserve.operational_cost_total_sale) || 0
  let totalOperationalCostPartner = (showFreeValue(props.reserve.reservation_brute_value) - totalOperationalCostTourView) * partnerComission / 100

  return (
    <>
      {!props.print &&
        <>
          <TableRow key={props.reserve.id} className="mb-7" onClick={() => setOpen(!open)}>
            <TableCell className="group py-2.5">
              {permissions.includes(props?.permission) && <Checkbox
                className={!props.reserve.select ? "hidden p-0 group-hover:block" : "p-0"}
                value={props.reserve.select}
                checked={props.reserve.select}
                onChange={(ev) => props.changeCheckbox(ev.target.checked, false, props.idx)}
                color="dark"
              />}
              {props.reserve.sale_status === 'canceled' &&
                <Icon className="mr-2 text-red-500">block</Icon>
              }{props.reserve.references}
            </TableCell>
            <TableCell className="py-2.5">
              {props.reserve.company_name}
            </TableCell>
            <TableCell className="py-2.5">
              {props.reserve.customer_name}
            </TableCell>
            <TableCell className="py-2.5">
              {props.reserve.travel_name}
              {props.reserve.transfer_type === 'in' ?
                <span className="items-center justify-center rounded-full ml-1 h-8 w-12 text-white" style={{ background: '#009C86E5' }}>
                  In
                </span>
                :
                ''
              }
              {props.reserve.transfer_type === 'out' ?
                <span className="items-center justify-center rounded-full ml-1 h-8 w-12 text-white" style={{ background: '#4480A8E5' }}>
                  Out
                </span>
                :
                ''
              }
            </TableCell>
            <TableCell className="py-2.5">{getRegionName()}</TableCell>
            <TableCell className="py-2.5">
              {props.reserve.payment_status === 'pending' || props.reserve.payment_status === 'partial' ?
                <>
                  Pendente
                  <Icon
                    className="ml-2 cursor-pointer"
                    fontSize="small"
                    onClick={() => setOpen(!open)}
                  >do_disturb_on
                  </Icon>
                </>
                : props.reserve.payment_status === 'accomplished' ?
                  <>
                    Realizado
                    <Icon
                      className="ml-2 check_circle"
                      fontSize="small"
                      onClick={() => setOpen(!open)}
                    >check_circle
                    </Icon>
                  </>
                  : ''}

            </TableCell>
            <TableCell className="py-2.5">
              <div className="flex items-center pr-4 space-x-5">
                <Moment format="DD/MM/YYYY" date={props.reserve.tour_date} />
              </div>
            </TableCell>

            {/* Valor Livre START */}

            {props.travelType !== 'transfer' ?
              <TableCell className="py-2.5">
                {props.type === 'seller' ?
                  <NumberFormat
                    value={props.reserve.status !== 'canceled' ? Number(showFreeValue(props.reserve.reservation_brute_value, true) - totalOperationalCostTourView - totalOperationalCostPartner) : 0 || 0}
                    displayType={'text'}
                    decimalSeparator={","}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    decimalPrecision={2}
                    thousandSeparator={"."}
                    isNumericString
                    prefix={`${process.env.REACT_APP_CURRENCY} `}
                    renderText={(value) => <span className="flex items-center">{value}</span>}
                  /> :
                  <NumberFormat
                    value={props.reserve.status !== 'canceled' ? Number((props.reserve.partner_commission_type === true ? showFreeValue(props.reserve.reservation_brute_value, true) - props.reserve.operational_cost_total : showFreeValue(props.reserve.reservation_brute_value, true))) : 0 || 0}
                    displayType={'text'}
                    decimalSeparator={","}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    decimalPrecision={2}
                    thousandSeparator={"."}
                    isNumericString
                    prefix={`${process.env.REACT_APP_CURRENCY} `}
                    renderText={(value) => <span className="flex items-center">{value}</span>}
                  />
                }
              </TableCell>
              :
              <TableCell className="py-2.5">
                {props.type === 'seller' ?
                  <NumberFormat
                    value={props.reserve.status !== 'canceled' ? Number(props.reserve.percentage_commission_region) : 0 || 0}
                    displayType={'text'}
                    decimalSeparator={","}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    decimalPrecision={2}
                    thousandSeparator={"."}
                    isNumericString
                    prefix={`${process.env.REACT_APP_CURRENCY} `}
                    renderText={(value) => <span className="flex items-center">{value}</span>}
                  />
                  :
                  <NumberFormat
                    value={props.reserve.status !== 'canceled' ? Number(props.reserve.percentage_commission) : 0 || 0}
                    displayType={'text'}
                    decimalSeparator={","}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    decimalPrecision={2}
                    thousandSeparator={"."}
                    isNumericString
                    prefix={`${process.env.REACT_APP_CURRENCY} `}
                    renderText={(value) => <span className="flex items-center">{value}</span>}
                  />
                }
              </TableCell>
            }

            {props.travelType !== 'transfer' ?
              <>
                <TableCell className="py-2.5">
                  {props.reserve.type === 'tour' ?
                    props.type === 'seller' ?
                      <NumberFormat
                        value={
                          props.reserve.status !== 'canceled'
                            ? Number(((
                              showFreeValue(props.reserve.reservation_brute_value, true)
                              - totalOperationalCostTourView
                              - totalOperationalCostPartner
                            ))
                              * (props.reserve.percentage_commission_region ? props.reserve.percentage_commission_region : props.reserve.max_percentage_commission) / 100) : 0 || 0
                        }

                        displayType={'text'}
                        decimalSeparator={","}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        decimalPrecision={2}
                        thousandSeparator={"."}
                        isNumericString
                        prefix={`${process.env.REACT_APP_CURRENCY} `}
                        renderText={(value) => <span className="flex items-center">{value}</span>}
                      />
                      :
                      <NumberFormat
                        value={props.reserve.status !== 'canceled' ? Number(props.reserve.partner_commission_type === true ? (showFreeValue(props.reserve.reservation_brute_value) - props.reserve.operational_cost_total) * (props.reserve.percentage_commission / 100) : (showFreeValue(props.reserve.reservation_brute_value)) * (props.reserve.percentage_commission / 100)) : 0 || 0}
                        displayType={'text'}
                        decimalSeparator={","}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        decimalPrecision={2}
                        thousandSeparator={"."}
                        isNumericString
                        prefix={`${process.env.REACT_APP_CURRENCY} `}
                        renderText={(value) => <span className="flex items-center">{value}</span>}
                      />
                    :
                    props.type === 'seller' ?
                      <NumberFormat
                        value={props.reserve.status !== 'canceled' ? Number(props.reserve.percentage_commission_region) : 0 || 0}
                        displayType={'text'}
                        decimalSeparator={","}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        decimalPrecision={2}
                        thousandSeparator={"."}
                        isNumericString
                        prefix={`${process.env.REACT_APP_CURRENCY} `}
                        renderText={(value) => <span className="flex items-center">{value}</span>}
                      />
                      :
                      <NumberFormat
                        value={props.reserve.status !== 'canceled' ? Number(props.reserve.percentage_commission) : 0 || 0}
                        displayType={'text'}
                        decimalSeparator={","}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        decimalPrecision={2}
                        thousandSeparator={"."}
                        isNumericString
                        prefix={`${process.env.REACT_APP_CURRENCY} `}
                        renderText={(value) => <span className="flex items-center">{value}</span>}
                      />
                  }
                </TableCell>
              </>
              :
              ''
            }
            <TableCell className="items-center justify-between py-2.5">
              {status[props.reserve.status] || 'Pendente'}
            </TableCell>
            <TableCell className="items-center justify-between p-0">
              <Icon
                className="ml-2 cursor-pointer"
                onClick={() => setOpen(!open)}
              >
                {open === true ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
              </Icon>
              {
                props.reserve.select && !props.checkAll &&
                <Icon
                  className="ml-2 cursor-pointer text-lightblue"
                  onClick={() => props.setOpenModal()}
                >
                  editar
                </Icon>
              }
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`py-0 ${!open ? 'border-0' : ''}`} colSpan={6}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <div className="flex py-4">
                  <div className="flex-1 font-semibold">
                    Valor bruto
                  </div>
                  <div className="flex-1 font-semibold">
                    Desconto gerencial
                  </div>
                  {props.reserve.type === 'tour' && props.type == 'seller' ?
                    <div className="flex-1 font-semibold">
                      Parceiro
                    </div>
                    : ''}
                  <div className="flex-1 font-semibold">
                    Custo operacional
                  </div>
                  <div className="flex-1 font-semibold">
                    {props.reserve.type === 'tour' ?
                      'Porcentagem de comissão'
                      :
                      'Comissão fixa'
                    }
                  </div>
                </div>
                <div className="flex items-center py-4">
                  <div className="flex-1">
                    <div className="flex items-center">
                      <div className="flex-1 ml-2">
                        <NumberFormat
                          value={Number(showFreeValue(props.reserve.reservation_brute_value, true)) || 0}
                          displayType={'text'}
                          decimalSeparator={","}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          decimalPrecision={2}
                          thousandSeparator={"."}
                          isNumericString
                          prefix={`${process.env.REACT_APP_CURRENCY} `}
                          renderText={(value) => <span className="flex items-center">{value}</span>}
                        />
                      </div>
                      {/* Desconto gerencial — sempre visível, valor só quando > 0 */}
                      <div className="flex-1 ml-2">
                        {Number(props.reserve.manager_discount_pct) > 0
                          ? <span style={{ color: '#a78bfa' }}>{props.reserve.manager_discount_pct}%</span>
                          : ''}
                      </div>
                      {/* PARA PASSEIOS */}
                      {props.reserve.type === 'tour' && props.type === 'seller' ?
                        <div className="flex-1 ml-2">
                          <NumberFormat
                            value={Number(totalOperationalCostPartner) || 0}
                            displayType={'text'}
                            decimalSeparator={","}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            decimalPrecision={2}
                            thousandSeparator={"."}
                            isNumericString
                            prefix={`${process.env.REACT_APP_CURRENCY} `}
                            renderText={(value) => <span className="flex items-center">{value}</span>}
                          />
                        </div>
                        : ''}
                      <div className="flex-1 ml-2">
                        {/* PARA TRANSFERS */}
                        {props.reserve.type === 'tour' ? <NumberFormat
                          //value={Number(!props.reserve.partner_seller_type ? totalOperationalCostTourView : totalOperationalCostPartner) || 0}
                          value={Number(totalOperationalCostTourView) || 0}
                          displayType={'text'}
                          decimalSeparator={","}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          decimalPrecision={2}
                          thousandSeparator={"."}
                          isNumericString
                          prefix={`${process.env.REACT_APP_CURRENCY} `}
                          renderText={(value) => <span className="flex items-center">{value}</span>}
                        /> :
                          <NumberFormat
                            value={Number(props.reserve.operational_cost_reserve) || 0}
                            displayType={'text'}
                            decimalSeparator={","}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            decimalPrecision={2}
                            thousandSeparator={"."}
                            isNumericString
                            prefix={`${process.env.REACT_APP_CURRENCY} `}
                            renderText={(value) => <span className="flex items-center">{value}</span>}
                          />}
                      </div>
                      <div className="flex-1 ml-2">
                        {props.reserve.type === 'tour' ?
                          props.type === 'seller' ?
                            <span>{props.reserve.status !== 'canceled' && props.reserve.percentage_commission_region ? props.reserve.percentage_commission_region : props.reserve.max_percentage_commission || 0}%</span>
                            :
                            <span>{props.reserve.percentage_commission || 0}%</span>
                          :
                          props.type === 'seller' ?
                            <span>{props.reserve.status !== 'canceled' && props.reserve.percentage_commission_region || 0}</span>
                            :
                            <span>{props.reserve.percentage_commission || 0}</span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </TableCell>
          </TableRow>
        </>
      }

      {props.print && props.travelType === 'transfer' && (props.reserve.company_id == props.company || props.company == 'all' || props.company == undefined) &&
        <TableRow key={props.reserve.id}>
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {props.reserve.references}
          </TableCell>
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {props.reserve.customer_name}
          </TableCell>
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {props.reserve.travel_name} - {props.reserve.transfer_type}
          </TableCell>
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {getRegionName()}
          </TableCell>
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {props.reserve.payment_status === 'pending' || props.reserve.payment_status === 'partial' ?
              <>
                Pendente
              </>
              : props.reserve.payment_status === 'accomplished' ?
                <>
                  Realizado
                </>
                : ''}
          </TableCell>
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {<Moment format="DD/MM/YYYY" date={props.reserve.tour_date} />}
          </TableCell>
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {
              props.type === 'seller' ?
                <NumberFormat
                  value={props.reserve.status !== 'canceled' ? Number(props.reserve.percentage_commission_region) : 0 || 0}
                  displayType={'text'}
                  decimalSeparator={","}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  decimalPrecision={2}
                  thousandSeparator={"."}
                  isNumericString
                  prefix={`${process.env.REACT_APP_CURRENCY} `}
                  renderText={(value) => <span className="flex items-center">{value}</span>}
                />
                :
                <NumberFormat
                  value={props.reserve.status !== 'canceled' ? Number(props.reserve.percentage_commission) : 0 || 0}
                  displayType={'text'}
                  decimalSeparator={","}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  decimalPrecision={2}
                  thousandSeparator={"."}
                  isNumericString
                  prefix={`${process.env.REACT_APP_CURRENCY} `}
                  renderText={(value) => <span className="flex items-center">{value}</span>}
                />
            }
          </TableCell>
          {props.travelType !== 'transfer' ? <>
            <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
              {props.reserve.type === 'tour' ?
                props.type === 'seller' ?
                  <NumberFormat
                    value={Number(((showFreeValue(props.reserve.reservation_brute_value) - totalOperationalCostTourView) - ((showFreeValue(props.reserve.reservation_brute_value) - totalOperationalCostTourView) * partnerComission / 100)) * (props.reserve.percentage_commission_region ? props.reserve.percentage_commission_region : props.reserve.max_percentage_commission) / 100) || 0}
                    displayType={'text'}
                    decimalSeparator={","}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    decimalPrecision={2}
                    thousandSeparator={"."}
                    isNumericString
                    prefix={`${process.env.REACT_APP_CURRENCY} `}
                    renderText={(value) => <span className="flex items-center">{value}</span>}
                  />
                  :
                  <NumberFormat
                    value={Number(props.reserve.partner_commission_type === true ? (showFreeValue(props.reserve.reservation_brute_value) - props.reserve.operational_cost_total) * (props.reserve.percentage_commission / 100) : (showFreeValue(props.reserve.reservation_brute_value)) * (props.reserve.percentage_commission / 100)) || 0}
                    displayType={'text'}
                    decimalSeparator={","}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    decimalPrecision={2}
                    thousandSeparator={"."}
                    isNumericString
                    prefix={`${process.env.REACT_APP_CURRENCY} `}
                    renderText={(value) => <span className="flex items-center">{value}</span>}
                  />
                :
                props.type === 'seller' ?
                  <NumberFormat
                    value={Number(props.reserve.percentage_commission_region) || 0}
                    displayType={'text'}
                    decimalSeparator={","}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    decimalPrecision={2}
                    thousandSeparator={"."}
                    isNumericString
                    prefix={`${process.env.REACT_APP_CURRENCY} `}
                    renderText={(value) => <span className="flex items-center">{value}</span>}
                  />
                  :
                  <NumberFormat
                    value={Number(props.reserve.percentage_commission) || 0}
                    displayType={'text'}
                    decimalSeparator={","}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    decimalPrecision={2}
                    thousandSeparator={"."}
                    isNumericString
                    prefix={`${process.env.REACT_APP_CURRENCY} `}
                    renderText={(value) => <span className="flex items-center">{value}</span>}
                  />
              }
            </TableCell>
          </> : ''}
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {status[props.reserve.status] || 'Pendente'}
          </TableCell>
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            <NumberFormat
              value={Number(showFreeValue(props.reserve.reservation_brute_value)) || 0}
              displayType={'text'}
              decimalSeparator={","}
              decimalScale={2}
              fixedDecimalScale={true}
              decimalPrecision={2}
              thousandSeparator={"."}
              isNumericString
              prefix={`${process.env.REACT_APP_CURRENCY} `}
              renderText={(value) => <span className="flex items-center">{value}</span>}
            />
          </TableCell>
          {props.reserve.type === 'tour' ?
            <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
              <NumberFormat
                value={Number((showFreeValue(props.reserve.reservation_brute_value) - totalOperationalCostTourView) * partnerComission / 100) || 0}
                displayType={'text'}
                decimalSeparator={","}
                decimalScale={2}
                fixedDecimalScale={true}
                decimalPrecision={2}
                thousandSeparator={"."}
                isNumericString
                prefix={`${process.env.REACT_APP_CURRENCY} `}
                renderText={(value) => <span className="flex items-center">{value}</span>}
              />
            </TableCell>
            : ''}
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            <NumberFormat
              value={Number(props.reserve.operational_cost_reserve) || 0}
              displayType={'text'}
              decimalSeparator={","}
              decimalScale={2}
              fixedDecimalScale={true}
              decimalPrecision={2}
              thousandSeparator={"."}
              isNumericString
              prefix={`${process.env.REACT_APP_CURRENCY} `}
              renderText={(value) => <span className="flex items-center">{value}</span>}
            />
          </TableCell>
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {props.reserve.type === 'tour' ?
              props.type === 'seller' ?
                <span>{props.reserve.status !== 'canceled' && props.reserve.percentage_commission_region ? props.reserve.percentage_commission_region : props.reserve.max_percentage_commission || 0}%</span>
                :
                <span>{props.reserve.status !== 'canceled' && props.reserve.percentage_commission || 0}%</span>
              :
              props.type === 'seller' ?
                <span>{props.reserve.status !== 'canceled' && props.reserve.percentage_commission_region || 0}</span>
                :
                <span>{props.reserve.status !== 'canceled' && props.reserve.percentage_commission || 0}</span>
            }
          </TableCell>
        </TableRow>
      }

      {props.print && props.travelType === 'tour' && (props.reserve.company_id == props.company || props.company == 'all' || props.company == undefined) &&
        <TableRow key={props.reserve.id}>
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {props.reserve.references}
          </TableCell>
          <TableCell className="py-2.5" width="10%" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {props.reserve.customer_name}
          </TableCell>
          <TableCell className="py-2.5" width="10%" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {props.reserve.travel_name} - {props.reserve.transfer_type}
          </TableCell>
          <TableCell className="py-2.5" width="10%" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>{getRegionName()}</TableCell>
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {props.reserve.payment_status === 'pending' || props.reserve.payment_status === 'partial' ?
              <>
                Pendente
              </>
              : props.reserve.payment_status === 'accomplished' ?
                <>
                  Realizado
                </>
                : ''}
          </TableCell>
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {<Moment format="DD/MM/YYYY" date={props.reserve.tour_date} />}
          </TableCell>
          {/* Ordem revista (2026-08-19): Valor bruto > Desconto gerencial > Parceiro >
              Custo operacional > Valor livre > % comissão > Comissão > Status.
              Nenhum cálculo mudou, só posição das células + a coluna nova (Desconto
              gerencial, informativa). */}
          {props.type === 'seller' ?
            <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
              <NumberFormat
                value={Number(showFreeValue(props.reserve.reservation_brute_value)) || 0}
                displayType={'text'}
                decimalSeparator={","}
                decimalScale={2}
                fixedDecimalScale={true}
                decimalPrecision={2}
                thousandSeparator={"."}
                isNumericString
                prefix={`${process.env.REACT_APP_CURRENCY} `}
                renderText={(value) => <span className="flex items-center">{value}</span>}
              />
            </TableCell>
            : ''}
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {Number(props.reserve.manager_discount_pct) > 0
              ? `${props.reserve.manager_discount_pct}%`
              : '-'}
          </TableCell>
          {props.reserve.type === 'tour' && props.type === 'seller' ?
            <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
              <NumberFormat
                //value={Number((showFreeValue(props.reserve.reservation_brute_value) - totalOperationalCostTourView) * partnerComission / 100) || 0}
                value={totalOperationalCostPartner}
                displayType={'text'}
                decimalSeparator={","}
                decimalScale={2}
                fixedDecimalScale={true}
                decimalPrecision={2}
                thousandSeparator={"."}
                isNumericString
                prefix={`${process.env.REACT_APP_CURRENCY} `}
                renderText={(value) => <span className="flex items-center">{value}</span>}
              />
            </TableCell>
            : ''}
          {props.type === 'seller' ?
            <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
              <NumberFormat
                value={Number(totalOperationalCostTourView) || 0}
                displayType={'text'}
                decimalSeparator={","}
                decimalScale={2}
                fixedDecimalScale={true}
                decimalPrecision={2}
                thousandSeparator={"."}
                isNumericString
                prefix={`${process.env.REACT_APP_CURRENCY} `}
                renderText={(value) => <span className="flex items-center">{value}</span>}
              />
            </TableCell>
            : ''}
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {props.type === 'seller' ?
              <NumberFormat
                //value={props.reserve.status !== 'canceled' ? Number((showFreeValue(props.reserve.reservation_brute_value) - totalOperationalCostTourView) - ((showFreeValue(props.reserve.reservation_brute_value) - totalOperationalCostTourView) * partnerComission / 100)) : 0 || 0}
                value={props.reserve.status !== 'canceled' ? Number(showFreeValue(props.reserve.reservation_brute_value) - totalOperationalCostTourView) : 0 || 0}
                displayType={'text'}
                decimalSeparator={","}
                decimalScale={2}
                fixedDecimalScale={true}
                decimalPrecision={2}
                thousandSeparator={"."}
                isNumericString
                prefix={`${process.env.REACT_APP_CURRENCY} `}
                renderText={(value) => <span className="flex items-center">{value}</span>}
              /> :
              <NumberFormat
                value={props.reserve.status !== 'canceled' ? Number((props.reserve.partner_commission_type === true ? showFreeValue(props.reserve.reservation_brute_value) - props.reserve.operational_cost_total : showFreeValue(props.reserve.reservation_brute_value))) : 0 || 0}
                displayType={'text'}
                decimalSeparator={","}
                decimalScale={2}
                fixedDecimalScale={true}
                decimalPrecision={2}
                thousandSeparator={"."}
                isNumericString
                prefix={`${process.env.REACT_APP_CURRENCY} `}
                renderText={(value) => <span className="flex items-center">{value}</span>}
              />
            }
          </TableCell>
          <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
            {props.reserve.type === 'tour' ?
              props.type === 'seller' ?
                <span>{props.reserve.percentage_commission_region ? props.reserve.percentage_commission_region : props.reserve.max_percentage_commission || 0}%</span>
                :
                <span>{props.reserve.percentage_commission || 0}%</span>
              :
              props.type === 'seller' ?
                <span>{props.reserve.percentage_commission_region || 0}</span>
                :
                <span>{props.reserve.percentage_commission || 0}</span>
            }
          </TableCell>
          {props.travelType !== 'transfer' ? <>
            <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
              {props.reserve.type === 'tour' ?
                props.type === 'seller' ?
                  <NumberFormat
                    //value={props.reserve.status !== 'canceled' ? Number(((showFreeValue(props.reserve.reservation_brute_value) - totalOperationalCostTourView) - ((showFreeValue(props.reserve.reservation_brute_value) - totalOperationalCostTourView) * partnerComission / 100)) * (props.reserve.percentage_commission_region ? props.reserve.percentage_commission_region : props.reserve.max_percentage_commission) / 100) : 0 || 0}
                    value={props.reserve.status !== 'canceled' ? Number(((showFreeValue(props.reserve.reservation_brute_value) - totalOperationalCostTourView)) * (props.reserve.percentage_commission_region ? props.reserve.percentage_commission_region : props.reserve.max_percentage_commission) / 100) : 0 || 0}
                    displayType={'text'}
                    decimalSeparator={","}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    decimalPrecision={2}
                    thousandSeparator={"."}
                    isNumericString
                    prefix={`${process.env.REACT_APP_CURRENCY} `}
                    renderText={(value) => <span className="flex items-center">{value}</span>}
                  />
                  :
                  <NumberFormat
                    value={props.reserve.status !== 'canceled' ? Number(props.reserve.partner_commission_type === true ? (showFreeValue(props.reserve.reservation_brute_value) - props.reserve.operational_cost_total) * (props.reserve.percentage_commission / 100) : (showFreeValue(props.reserve.reservation_brute_value)) * (props.reserve.percentage_commission / 100)) : 0 || 0}
                    displayType={'text'}
                    decimalSeparator={","}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    decimalPrecision={2}
                    thousandSeparator={"."}
                    isNumericString
                    prefix={`${process.env.REACT_APP_CURRENCY} `}
                    renderText={(value) => <span className="flex items-center">{value}</span>}
                  />
                :
                props.type === 'seller' ?
                  <NumberFormat
                    value={Number(props.reserve.percentage_commission_region) || 0}
                    displayType={'text'}
                    decimalSeparator={","}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    decimalPrecision={2}
                    thousandSeparator={"."}
                    isNumericString
                    prefix={`${process.env.REACT_APP_CURRENCY} `}
                    renderText={(value) => <span className="flex items-center">{value}</span>}
                  />
                  :
                  <NumberFormat
                    value={Number(props.reserve.percentage_commission) || 0}
                    displayType={'text'}
                    decimalSeparator={","}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    decimalPrecision={2}
                    thousandSeparator={"."}
                    isNumericString
                    prefix={`${process.env.REACT_APP_CURRENCY} `}
                    renderText={(value) => <span className="flex items-center">{value}</span>}
                  />
              }
            </TableCell>
          </> : ''}
          {props.type === 'seller' ?
            <TableCell className="py-2.5" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
              {status[props.reserve.status] || 'Pendente'}
            </TableCell>
            : ''}
        </TableRow>
      }
    </>
  );
}

const SalesReserveTable = (props) => {
  const [result, setResult] = useState({})
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [status, setStatus] = useState(null);
  const [openModal, setOpenModal] = useState(false)
  const [selectedsIds, setSelectedsIds] = useState([]);
  const [allSelecteds, setAllSelecteds] = useState(false);
  const [totalFreeValue, setTotalFreeValue] = useState(0)
  const [totalCommission, setTotalCommission] = useState(0)
  const [tours, setTours] = useState([])

  let params = props.params

  useEffect(() => {
    //getTours()
  }, [])

  const getTours = async () => {
    const response = await apiClient.httpInstance.get(`/tours?pageSize=500`)

    if (response.status === 200) {
      return response.data.data
    }
  }

  // Fix (2026-08-19): revertido o fix de 2026-08-17. `value` (reservation_brute_value
  // = reservations.price) JÁ vem líquido de customer_discount e manager_discount_pct
  // (cadeia completa em PreSaleController::convertInSale — confirmado com dados
  // reais de produção). O fix anterior replicou a fórmula de
  // CommissionService::createTourCommission() achando que ela estava certa, mas ela
  // tinha o mesmo bug (também corrigido hoje) — os dois lados ficaram consistentes
  // entre si, mas descontando os 2 descontos DE NOVO em cima de um valor já líquido.
  // "Valor bruto" = o valor real pago pelo tour = value, sem subtração nenhuma.
  const showFreeValue = (value, element, tours_) => {
    return parseFloat(value) || 0
  }

  const handleChangePage = (event, newPage) => {
    getReserveBySeller(props.path, newPage, pageSize, params)
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(event.target.value);
    getReserveBySeller(props.path, page, event.target.value, params)
  };

  const getReserveBySeller = async (path, page, pageSize, params) => {
    let totalFree = 0
    let totalCommission = 0

    const tours_ = await getTours()

    apiClient.httpInstance.get(path, {
      params: {
        ...params,
        //page: page + 1,
        pageSize: 10000 //pageSize
      }
    }).then(response => {
      if (response.status === 200) {
        const data = response.data.data.map(obj => ({
          ...obj,
          select: false
        }))
        response.data.data = data
        for (let i = 0; i < response.data.data.length; i++) {
          var element = response.data.data[i];
          //data.forEach(element => {

          const brute_value = showFreeValue(element.reservation_brute_value, element, tours_)
          // Fix (2026-08-27): o filtro só checava element.status (status da reserva/
          // traslado individual), mas o ícone de cancelado (🚫) ao lado da referência
          // usa element.sale_status (status da VENDA inteira) — dois campos diferentes.
          // Quando a venda inteira era cancelada mas o status da reserva em si não
          // vinha 'canceled', a linha continuava entrando na soma mesmo com o ícone de
          // cancelado visível (caso real: Mara Talita, OR6A5261E2E337E, Total comissão
          // Transfer mostrava R$330 incluindo R$20 de uma venda cancelada — deveria ser
          // R$310, que já é o valor certo no Dashboard).
          if (element.status !== 'canceled' && element.sale_status !== 'canceled') {
            if (props.type === 'seller') {
              let totalOperationalCost = 0;

              //Novo cálculo
              if (element.tour_date < '2023-09-15') {
                //Comissões anteriores a 15/09/2023
                if (element.partner_seller_id && element.partner_seller_type) {
                  totalOperationalCost = parseInt(element.operational_cost_total)
                } else if (element.partner_seller_id) {
                  if (parseInt(element.operational_cost_total_sale) > 0) {
                    totalOperationalCost = parseFloat(element.operational_cost_total_sale)
                  } else {
                    totalOperationalCost = parseFloat(element.operational_cost_total_sale) + parseFloat(element.operational_cost_total)
                  }
                } else {
                  totalOperationalCost = parseFloat(element.operational_cost_total_sale) + parseFloat(element.operational_cost_total)
                }
              } else {
                //Comissões posteriores a 15/09/2023, novo cálculo com separação do valor de venda e de parceiro em cada passeio
                if (element.partner_seller_id && element.partner_seller_type) {
                  totalOperationalCost = parseInt(element.operational_cost_total_sale)
                } else if (element.partner_seller_id) {
                  if (parseInt(element.operational_cost_total_sale) > 0) {
                    totalOperationalCost = parseFloat(element.operational_cost_total_sale)
                  } else {
                    totalOperationalCost = parseFloat(element.operational_cost_total)
                  }
                } else {
                  totalOperationalCost = parseFloat(element.operational_cost_total_sale)
                }
              }

              if (element.type === 'tour') {
                totalFree += parseFloat(brute_value) - totalOperationalCost
              } else if (element.type === 'transfer') {
                totalFree += parseFloat(brute_value) - parseFloat(element.operational_cost_reserve)
              }
              //Se existir parceiro, subtrai do valor livre
              if (element.partner_seller_id /* && element.partner_seller_type */) {
                if (element.type === 'tour') {
                  totalFree -= (brute_value - totalOperationalCost) * element.percentage_commission_partner / 100
                }
              }

              if (element.type === 'tour') {
                if (element.percentage_commission_region && element.percentage_commission_region !== null) {
                  let totalOperationalCostCalc = element.partner_seller_id && element.partner_seller_type ? parseFloat(element.operational_cost_total) : element.partner_seller_id ? parseInt(element.operational_cost_total_sale) > 0 ? parseFloat(element.operational_cost_total_sale) : parseFloat(element.operational_cost_total_sale) + parseFloat(element.operational_cost_total) : parseFloat(element.operational_cost_total)
                  let partnerComissionCalc = element.partner_seller_id && element.partner_seller_type ? element.percentage_commission : element.percentage_commission_partner
                  
                  totalCommission += Number((
                    (brute_value - totalOperationalCost)
                    - ((brute_value - totalOperationalCost)
                      * (partnerComissionCalc || 0) / 100))
                    * (element.percentage_commission_region ? element.percentage_commission_region : element.max_percentage_commission) / 100) || 0;
                } else if (element.max_percentage_commission && element.max_percentage_commission !== null) {

                  let totalOperationalCostCalc = element.partner_seller_id && element.partner_seller_type ? parseFloat(element.operational_cost_total) : element.partner_seller_id ? parseInt(element.operational_cost_total_sale) > 0 ? parseFloat(element.operational_cost_total_sale) : parseFloat(element.operational_cost_total_sale) + parseFloat(element.operational_cost_total) : parseFloat(element.operational_cost_total)
                  totalCommission += ((brute_value - totalOperationalCostCalc) * element.max_percentage_commission / 100)
                }
              } else if (element.type === 'transfer') {
                totalCommission += Number(element.percentage_commission_region)
              }
            } else {
              if (element.partner_commission_type === true) {
                var operational_cost_total_sale = element.operational_cost_total ? element.operational_cost_total  : 0;
                totalFree += parseFloat(brute_value - operational_cost_total_sale);
                if (element.type === 'tour') {
                  if (element.percentage_commission && element.percentage_commission !== null) {
                    totalCommission += ((brute_value - element.operational_cost_total) * element.percentage_commission / 100)
                  }
                } else if (element.type === 'transfer') {
                  totalCommission += Number(element.percentage_commission)
                }
              } else {
                totalFree += parseFloat(brute_value)
                if (element.type === 'tour') {
                  if (element.percentage_commission && element.percentage_commission !== null) {
                    totalCommission += ((brute_value) * element.percentage_commission / 100)
                  }
                } else if (element.type === 'transfer') {
                  totalCommission += Number(element.percentage_commission)
                }
              }
            }
          }
        }
        //});

        setTotalFreeValue(totalFree)
        setTotalCommission(totalCommission)

        setResult({
          ...response.data,
          checkAll: false
        });
        setLoading(false)
      }
    })
      .catch((error) => console.log(error));
  }

  const changeCheckbox = (value, all, idx) => {
    if (!all && value === true && !selectedsIds.includes(result.data[idx]?.id)) {
      setSelectedsIds([...selectedsIds, result.data[idx]?.id])
    }

    if (!all && value === false && selectedsIds.includes(result.data[idx]?.id)) {
      setSelectedsIds(selectedsIds.filter(function (element) {
        return element !== result.data[idx]?.id
      }))
    }

    if (all) {
      if (value === false) {
        setSelectedsIds([])
      }
      const data = result.data.map(obj => ({
        ...obj,
        select: value
      }))
      data.forEach(element => {
        if (!selectedsIds.includes(element.id)) {
          selectedsIds.push(element.id)
        }
      });
      result.data = data
      setResult({
        ...result,
        checkAll: value
      })
    } else {
      let newArr = { ...result }
      newArr.data[idx]['select'] = value
      setResult(newArr)
    }
  }

  const handleUpdateStatus = () => {
    updateStatus(selectedsIds)
  }

  const updateStatus = async (ids) => {
    setLoading(true)
    var formData = new FormData;
    for (var i = 0; i < ids.length; i++) {
      formData.append('ids[]', ids[i]);
    }
    await apiClient.httpInstance.put(`/commissions/${props.type}/${props.id}/update_status`, {
      status,
      comissions_ids: ids
    }).then(response => {
      if (response.status === 200) {
        getReserveBySeller(props.path, page, pageSize, params);
        setLoading(false)
        setSelectedsIds([])
        setOpenModal(false)
        if (props.onStatusUpdate) props.onStatusUpdate();
      }
    })
      .catch((error) => {
        setLoading(false)
        console.log(error)
      });
  }

  const handleOpenModal = (reservation_id) => {
    setOpenModal(true)
  }

  useEffect(() => {
    if (props.get_data_reservations === true)
      getReserveBySeller(props.path, page, pageSize, params);
  }, [props.path, page, pageSize, params]);

  return <>
    <div className="flex flex-row-reverse my-7">
      <div className="row flex items-center space-x-4">
        {/* Fix (2026-08-17): traslado é comissão de VALOR FIXO, não faz sentido
            mostrar "Total livre" (conceito de valor bruto − custo operacional,
            só existe pra passeio) — mostra direto "Total comissão Transfer". */}
        {params.travelType === 'transfer' ? (
          <span className="font-bold text-blue">Total comissão Transfer: <NumberFormat
            value={Number(totalCommission) || 0}
            displayType={'text'}
            decimalSeparator={","}
            decimalScale={2}
            fixedDecimalScale={true}
            decimalPrecision={2}
            thousandSeparator={"."}
            isNumericString
            prefix={`${process.env.REACT_APP_CURRENCY} `}
            renderText={(value) => <span className="text-blue font-semibold">{value}</span>}
          /></span>
        ) : (
          <>
            <span className="font-bold text-blue">Total livre: <NumberFormat
              value={Number(totalFreeValue) || 0}
              displayType={'text'}
              decimalSeparator={","}
              decimalScale={2}
              fixedDecimalScale={true}
              decimalPrecision={2}
              thousandSeparator={"."}
              isNumericString
              prefix={`${process.env.REACT_APP_CURRENCY} `}
              renderText={(value) => <span className="text-green-600">{value}</span>}
            /></span>
            <span className="font-bold text-blue">Total comissão: <NumberFormat
              value={Number(totalCommission) || 0}
              displayType={'text'}
              decimalSeparator={","}
              decimalScale={2}
              fixedDecimalScale={true}
              decimalPrecision={2}
              thousandSeparator={"."}
              isNumericString
              prefix={`${process.env.REACT_APP_CURRENCY} `}
              renderText={(value) => <span className="text-blue font-semibold">{value}</span>}
            /></span>
          </>
        )}
      </div>
      {props.month ?
        <div className="flex flex-row-reverse">
          <div className="row flex-end"><small><small>Total referente ao mês de {props.month}</small></small></div>
        </div>
        : ''}
    </div>

    <Paper style={props.print ? { width: '100%', overflow: 'hidden', boxShadow: 'none' } : { width: '100%', overflow: 'hidden' }}>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            {!props.print &&
              <TableRow>
                <TableCell className="font-bold bg-white group">
                  {permissions.includes(props?.permission) && <Checkbox
                    className={!result.checkAll ? "hidden p-0 group-hover:block" : "p-0"}
                    value={result.checkAll}
                    checked={result.checkAll}
                    onChange={(ev) => changeCheckbox(ev.target.checked, true)}
                    color="dark"
                  />}
                  Referência
                </TableCell>
                <TableCell className="font-bold bg-white">
                  Empresa
                </TableCell>
                <TableCell className="font-bold bg-white">
                  Cliente
                </TableCell>
                <TableCell className="font-bold bg-white">
                  {params.travelType === 'tour' ? 'Passeio' : 'Traslado'}
                </TableCell>
                <TableCell className="font-bold bg-white">Região do {params.travelType === 'tour' ? 'Passeio' : 'Traslado'}</TableCell>
                <TableCell className="font-bold bg-white">
                  Pagamento
                </TableCell>
                <TableCell className="font-bold bg-white">
                  Data do passeio
                </TableCell>
                {params.travelType !== 'transfer' ?
                  <TableCell className="font-bold bg-white">
                    Valor livre
                  </TableCell>
                  : ''}
                <TableCell className="font-bold bg-white">
                  Comissão
                </TableCell>
                <TableCell className="items-center justify-between font-bold bg-white">
                  Status da comissão
                  {
                    result.checkAll &&
                    <Icon
                      className="ml-2 cursor-pointer text-lightblue"
                      onClick={() => setOpenModal(true)}
                    >
                      editar
                    </Icon>
                  }
                </TableCell>
              </TableRow>
            }
            {props.print && params.travelType === 'transfer' &&
              <TableRow>
                <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                  Referência
                </TableCell>
                <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                  Cliente
                </TableCell>
                <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                  Traslado
                </TableCell>
                <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>Região do Traslado</TableCell>
                <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                  Pagamento
                </TableCell>
                <TableCell className="font-bold bg-white" width="10%" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                  Data do passeio
                </TableCell>
                <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                  Comissão
                </TableCell>
                {props.type === 'seller' ?
                  <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                    Status
                  </TableCell>
                  : ''}
                {props.type === 'seller' ?
                  <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                    Valor bruto
                  </TableCell>
                  : ''}
                {props.type === 'seller' ?
                  <TableCell className="font-bold bg-white" width="10%" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                    Custo operacional
                  </TableCell>
                  : ''}
                <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                  Comissão fixa
                </TableCell>
              </TableRow>
            }
            {/* Ordem revista (2026-08-19): Valor bruto > Desconto gerencial (nova coluna,
                informativa) > Parceiro > Custo operacional > Valor livre > % comissão >
                Comissão > Status, pra deixar o relatório impresso sem ambiguidade. Nenhum
                cálculo mudou, só posição/rótulo das colunas + a coluna nova. */}
            {props.print && params.travelType === 'tour' &&
              <TableRow>
                <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                  Referência
                </TableCell>
                <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                  Cliente
                </TableCell>
                <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                  Passeio
                </TableCell>
                <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>Região do Passeio</TableCell>
                <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                  Pagamento
                </TableCell>
                <TableCell className="font-bold bg-white" width="10%" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                  Data do passeio
                </TableCell>
                {props.type === 'seller' ?
                  <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                    Valor bruto
                  </TableCell>
                  : ''}
                <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                  Desconto gerencial
                </TableCell>
                {props.type === 'seller' ?
                  <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                    Parceiro
                  </TableCell>
                  : ''}
                {props.type === 'seller' ?
                  <TableCell className="font-bold bg-white" width="10%" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                    Custo operacional
                  </TableCell>
                  : ''}
                <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                  Valor livre
                </TableCell>
                <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                  % comissão
                </TableCell>
                <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                  Comissão
                </TableCell>
                {props.type === 'seller' ?
                  <TableCell className="font-bold bg-white" style={{ fontSize: '0.6rem', padding: '0.25rem' }}>
                    Status
                  </TableCell>
                  : ''}
              </TableRow>
            }
          </TableHead>
          <TableBody>
            {!loading &&
              <>
                {result.data.map((obj, idx) => {
                  return (
                    <TableBodyData
                      tours={tours}
                      checkAll={result.checkAll}
                      reserve={obj}
                      changeCheckbox={changeCheckbox}
                      idx={idx}
                      setOpenModal={handleOpenModal}
                      print={props.print}
                      type={props.type}
                      travelType={params.travelType}
                      permission={props.permission}
                    />
                  )
                }
                )}
              </>
            }
          </TableBody>
        </Table>
      </TableContainer>
      {props.print &&
        <div className="py-4 px-2" style={{ fontSize: '0.7rem' }}>
          Obs: o desconto gerencial já está descontado do valor bruto (junto com o desconto pela forma de pagamento) — a coluna é apenas informativa.
        </div>
      }
      {/* {!props.print &&
        <TablePagination
          rowsPerPageOptions={[5, 10, 15]}
          component="div"
          count={result.total}
          rowsPerPage={pageSize}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      } */}
    </Paper>
    <ChangeStateModal
      open={openModal}
      loading={loading}
      close={() => setOpenModal(false)}
      onCreate={handleUpdateStatus}
      status={status}
      setStatus={setStatus}
      {...props}
    />
  </>
}

export default SalesReserveTable;